import React, { lazy, Suspense } from "react";
import Backdrop from "components/common-components/backdrop";

const Default = lazy(() => import("../../../../../layouts/dashboard/default"));
const AllCouncils = lazy(() => import("../pages/all-councils"));

export const CouncilRouter = [
  {
    path: "/master-management/council",
    element: (
      <Suspense fallback={<Backdrop />}>
        <Default />
      </Suspense>
    ),
    children: [
      {
        path: "all",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AllCouncils />
          </Suspense>
        ),
      },
    ],
  },
];
